import primary from './primary';

const dark = (params) => primary(params);

export default dark;
